import { render, staticRenderFns } from "./ImageExtensionView.vue?vue&type=template&id=5459af61&scoped=true&"
import script from "./ImageExtensionView.vue?vue&type=script&lang=js&"
export * from "./ImageExtensionView.vue?vue&type=script&lang=js&"
import style0 from "./ImageExtensionView.vue?vue&type=style&index=0&id=5459af61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459af61",
  null
  
)

export default component.exports